// @ts-nocheck
import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from './../../../RCUtils';
import $ from 'jquery';
import animatedloader from '../../../images/animated-loader.gif';
import lodashfilter from 'lodash/filter';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface DeforstState {
    SelectedReefers: any[];
    DeforstInterval: string;
    IntervalDropdownValues: any[];
    SelectedInterval: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    isInputBox: boolean;
    VCCheckBoxInfo: VCCheckBoxData; 
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class ChangeDeforstInterval extends React.Component<any, DeforstState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], DeforstInterval: "", IntervalDropdownValues: [], SelectedInterval: "", RowData: [], Filters: filterSet, isInputBox: false, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        if (reeferData != null && reeferData != undefined && reeferData.length > 0) {
            this.setState({ SelectedReefers: reeferData, DeforstInterval: "" });
            this.renderDeforstInterval(reeferData, this.props.isChangeDeforstInterval, reeferData[0].ReeferOEMTypeCd, this.props.reeferFormatter.RefControllerTypes);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

        $('#deforstLoader').hide();
    }

    onDeforstIntervalChange(event: React.FormEvent<HTMLInputElement>) {
        var interval = this.state.DeforstInterval;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            interval = Value;
        else
            return;
        this.setState({ DeforstInterval: interval });
    }

    submitDeforst() {
        if (this.state.DeforstInterval == "") {
            PopupWindow.showErrorMessage("Alert", "Interval should not be empty.");
        }
        else if ((parseInt(this.state.DeforstInterval) < 2 || parseInt(this.state.DeforstInterval) > 48) && this.state.isInputBox == true)
        {
            PopupWindow.showErrorMessage("Alert", "Interval should be with in range(2-48).");
        }
        else {
            var command = "ChangeDeforstInterval";
            var refreshGrid = this.props.refreshGrid;
            ReeferCommandsGrid.submitTemperatureCommands(command, this.state.DeforstInterval, refreshGrid);
            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        }
    }

    IntervalDropdownChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({ DeforstInterval: Value });
    }

    componentWillReceiveProps(nextProps: any) {
        var reeferData = nextProps.reeferData;

        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            this.renderDeforstInterval(reeferData, nextProps.isChangeDeforstInterval, reeferData[0].ReeferOEMTypeCd, nextProps.reeferFormatter.RefControllerTypes);
        }
        if (nextProps.VCCheckBoxInfo != undefined && nextProps.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextProps.VCCheckBoxInfo });
        }
    }

    renderDeforstInterval(reeferData: any, isChangeDeforstInterval: boolean, selectedOem: string, refControllerTypes: any) {
        if (selectedOem.trim() !="S") {
            $('#deforstLoader').show();
            $('#divIntervalRange').hide();
            $('#divtxtInterval').hide();
            $('#divdrpInterval').show();

            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetIntervalsForDefrostChange';
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data != null && data != undefined) {
                        var dataArray = data.split(',');
                        if (selectedOem.trim() == "D") {
                            var filteredDaikinDataArray = dataArray.filter(function (item) {
                                return item.trim() !== "OFF" && item.trim() !== "AUTO" && item.trim() !== "AUTO2" && item.trim() !== "AUTO3"
                                    && item.trim() !== "2";
                            });
                            dataArray = filteredDaikinDataArray;
                        }
                        else {
                                var controllerDesc = "";
                            var controllertype = lodashfilter(refControllerTypes, function (item) {
                                    return item.ControllerTypeCd === reeferData[0].ControllerTypeCd;
                                });
                                if (controllertype.length > 0 && controllertype != null) {
                                    controllerDesc = controllertype[0].ControllerDesc;
                                }
                            if (!(controllerDesc == 'ML5' && reeferData[0].DeviceType != null && (reeferData[0].DeviceType.toString().trim().toUpperCase() == 'CT3500' || reeferData[0].DeviceType.toString().trim().toUpperCase() == 'CT3600'))) {
                                var filteredCarrierDataArray = dataArray.filter(function (item) {
                                    return item.trim() !== "AUTO" && item.trim() !== "AUTO2" && item.trim() !== "AUTO3"
                                        && item.trim() !== "2";
                                });
                                dataArray = filteredCarrierDataArray;
                            }
                        }
                        var isDropdown = $('#divdrpInterval').is(":visible");
                        if (isDropdown = true)
                            this.setState({ IntervalDropdownValues: dataArray, DeforstInterval: dataArray[0].toString(), isInputBox: false});
                        else
                            this.setState({ IntervalDropdownValues: dataArray, DeforstInterval: dataArray[0].toString(), isInputBox: false});
                    }
                    $('#deforstLoader').hide();
                });

        }
        else {
            $('#divIntervalRange').show();
            $('#divtxtInterval').show();
            this.setState({ DeforstInterval: "" });
            $('#divdrpInterval').hide();
            this.setState({isInputBox: true });
        }

        this.setState({ SelectedReefers: reeferData});
        this.state.Filters.CommandName = "ChangeDeforstInterval";
        this.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
            });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "ChangeDeforstInterval", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div id="deforstLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
            <div className="modal-controls-container">                
                <div className='row'>
                    <div className='col-lg-5 col-md-6 col-sm-6 col-xs-6 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Set Defrost Interval (In Hours) :</label>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'>

                        <div id='divtxtInterval'>
                            <input type='text' id='txtInterval' className='form-control' placeholder='' required onChange={e => this.onDeforstIntervalChange(e)} value={this.state.DeforstInterval} />
                        </div>
                        <div id='divdrpInterval'>
                            <select className='form-select' id='selectInterval' onChange={e => this.IntervalDropdownChange(e)} value={this.state.DeforstInterval}>
                                {
                                    this.state.IntervalDropdownValues.map((item, index) =>
                                        <option key={index} value={item}>{item}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-3' id='divIntervalRange'>
                        <span className='alert alert-danger'>Interval between 2 to 48</span>
                    </div>
                </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"ChangeDeforstInterval"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitDeforst.bind(this)}>Save</button>
               
            </div>
        </div>
    }
}